import { useGetCurrencies } from '@wwe-portal/web/providers/queries/offer';
import { useGlobalStore } from '@wwe-portal/web/providers/stores/global-store';

export const useCurrentCurrency = () => {
  const { currencyId, setCurrencyId } = useGlobalStore((state) => state);
  const { data, isLoading } = useGetCurrencies();
  const currencies = data?.data.data.filter((item) => item.typeId === 2);
  const currency =
    currencies?.find((item) => item.id === currencyId) ?? currencies?.[0];
  const changeCurrency = (id: number) => {
    setCurrencyId(id);
  };
  return {
    currency,
    changeCurrency,
    currencies,
    isLoading,
  };
};
